import { createContext } from 'react';

const ExtraAreaContext = createContext(() => {});

export default ExtraAreaContext;
